"use strict";
exports.__esModule = true;
var redux_form_1 = require("redux-form");
// @ts-ignore
redux_form_1.Field.defaultProps = {
    autoComplete: 'off'
};
exports["default"] = redux_form_1.Field;
